import React, { Component } from 'react'
import { SNavigation, SText, STheme, SView } from 'servisofts-component2';
import Menu from "../../../Assets/menu.svg"
import Tuerca from "../../../Assets/tuerca.svg"

import { TopBarPropsType } from '..';
export default class index extends Component<TopBarPropsType> {

    render() {
        return (<SView col={"xs-12"} height={60} backgroundColor={STheme.color.barColor} center row style={{
            borderBottomLeftRadius: 8, borderBottomRightRadius: 8,
        }}>
            <SView width={50} height center onPress={() => {
                //  NavBar.open(); 
            }}>
                <Menu width={32} />
            </SView>
            <SView flex center height>
                <SText color={STheme.color.text} fontSize={18}>{this.props.title}</SText>
            </SView>
            <SView width={50} height center onPress={() => {
                SNavigation.navigate('/ajustes');
            }}>
                <Tuerca width={24} height={24} fill={STheme.color.secondary} />
            </SView>
        </SView>)
    }
}